import { render, staticRenderFns } from "./AttachmentInfo.vue?vue&type=template&id=46766e6c&scoped=true&"
import script from "./AttachmentInfo.vue?vue&type=script&lang=js&"
export * from "./AttachmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentInfo.vue?vue&type=style&index=0&id=46766e6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46766e6c",
  null
  
)

export default component.exports